<template>
  <el-dialog title="自定义排序" :visible.sync="visible" width="870px">
    <div class="custom-sort-modal" ref="customSortModalRef">
      <div class="custom-sort-group" v-if="groupName">
        <span>{{ groupName }}</span>
      </div>
      <el-button type="text" v-if="list.length === 0" @click="addEmptyHandle()">
        <i class="el-icon-plus"></i>
        <span>添加排序</span>
      </el-button>
      <div class="custom-sort-ul">
        <div
          class="custom-sort-item"
          v-for="(item, idx) in list"
          :key="item.uniqueId"
          :class="{ 'is-high-light': highlighItem === item.uniqueId }"
        >
          <el-select
            v-model="item.fieldInfo"
            value-key="_id"
            filterable
            placeholder="请选择标签"
            @change="changeFieldHandle(idx)"
          >
            <el-option v-if="item.fieldInfo" hidden :value="item.fieldInfo" :label="item.fieldInfo.title" />
            <el-option v-for="fieldInfo in fields" :key="fieldInfo._id" :value="fieldInfo" :label="fieldInfo.title" />
          </el-select>

          <el-select :value="item.fieldInfo ? item.fieldInfo._id : ''" placeholder="标签类型">
            <el-option v-if="item.fieldInfo" :value="item.fieldInfo._id" :label="getFieldTypeLabel(item.fieldInfo)" />
          </el-select>

          <el-select v-model="item.sortWay" placeholder="请选择排序规则" class="sort-way-select">
            <el-popover
              slot="prefix"
              v-if="item.fieldInfo && item.fieldInfo.deputy_type === 'dict' && item.sortWay === 'DICT_COUNT'"
              placement="bottom"
              title=""
              trigger="click"
              @show="loadDictValHandle(item)"
              :offset="-48"
              popper-class="sort-field-dict-preview-popover"
            >
              <el-button slot="reference" type="text" @click.stop="">
                <span>预览</span>
              </el-button>
              <div
                class="sort-field-dict-list"
                v-if="dictValInfo[getDictValKey(item)]"
                v-loading="dictValInfo[getDictValKey(item)].loading"
              >
                <div
                  class="sort-field-dict-text"
                  :style="{ textAlign: 'center', margin: '30px 0' }"
                  v-if="
                    !dictValInfo[getDictValKey(item)].loading && dictValInfo[getDictValKey(item)].dictList.length === 0
                  "
                >
                  <span>该标签暂无分类值</span>
                </div>
                <div
                  class="sort-field-dict-text"
                  v-for="(dictText, dictIdx) in dictValInfo[getDictValKey(item)].dictList"
                  :key="dictIdx"
                >
                  <span>{{ dictText }}</span>
                </div>
              </div>
            </el-popover>

            <el-option
              v-for="wayItem in getSortWayOptions(item.fieldInfo)"
              :key="wayItem.value"
              :value="wayItem.value"
              :label="wayItem.label"
            />
          </el-select>

          <el-select v-model="item.multiHandler" placeholder="请选择标签多值的处理方式" :style="{ width: '210px' }">
            <el-option
              v-for="mulitHandler in getmultiHandlerOptions(item.fieldInfo)"
              :key="mulitHandler.value"
              :value="mulitHandler.value"
              :label="mulitHandler.label"
            />
          </el-select>

          <div class="custom-sort-tools">
            <i class="el-icon-circle-plus-outline" @click="addEmptyHandle(idx)"></i>
            <i class="el-icon-remove-outline" @click="removeHandle(idx)"></i>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="confirmHandle">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script setup>
import { cloneDeep, uniqueId, uniqBy } from 'lodash';
import { computed, onMounted, ref, nextTick } from 'vue';
import { couldGroupFiled, errFunc, getSortWayOptions } from '@/lib/utils';
import { Message } from 'element-ui';
import { services } from '@/service';

const emit = defineEmits(['update:show', 'change']);
const props = defineProps(['show', 'courseId', 'fields', 'defaultFieldDetail', 'defaultSortInfoCustom', 'groupName']);

const visible = computed({
  get() {
    return props.show;
  },
  set(val) {
    emit('update:show', val);
  }
});

const customSortModalRef = ref(null);
const list = ref([]);
const highlighItem = ref('');
onMounted(() => {
  list.value = cloneDeep(props.defaultSortInfoCustom);

  if (props.defaultFieldDetail) {
    const idx = list.value.findIndex(o => o.fieldInfo._id === props.defaultFieldDetail._id);
    if (idx === -1) {
      highlighItem.value = uniqueId('custom_sort_');
      list.value = [
        ...list.value,
        {
          uniqueId: highlighItem.value,
          fieldInfo: props.defaultFieldDetail,
          sortWay: getSortWayOptions(props.defaultFieldDetail)[0].value,
          multiHandler: getmultiHandlerOptions(props.defaultFieldDetail)[0].value
        }
      ];
      nextTick(() => {
        customSortModalRef.value.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    } else {
      highlighItem.value = list.value[idx].uniqueId;
    }
  }

  if (list.value.length < 1) {
    addEmptyHandle();
  }
});

const addEmptyHandle = (idx = -1) => {
  const newList = [...list.value];

  newList.splice(idx + 1, 0, {
    uniqueId: uniqueId('custom_sort_'),
    fieldInfo: null,
    sortWay: '',
    multiHandler: ''
  });

  list.value = newList;
};

const removeHandle = idx => {
  const newList = [...list.value];

  newList.splice(idx, 1);

  list.value = newList;
};

const changeFieldHandle = idx => {
  const newList = [...list.value];

  const fieldInfo = newList[idx].fieldInfo;

  newList.splice(idx, 1, {
    ...newList[idx],
    sortWay: getSortWayOptions(fieldInfo)[0].value,
    multiHandler: getmultiHandlerOptions(fieldInfo)[0].value
  });

  list.value = newList;
};

const confirmHandle = () => {
  const arr = list.value.filter(item => {
    return !!item.fieldInfo;
  });
  if (arr.length !== uniqBy(arr, o => o.fieldInfo._id).length) {
    Message.warning('标签重复了，请修改或者删除重复标签');
    return;
  }
  visible.value = false;
  emit('change', arr);
};

const getFieldTypeLabel = fieldDetail => {
  if (couldGroupFiled(fieldDetail)) {
    if (fieldDetail.deputy_type === 'dict') {
      return '分类文本';
    } else {
      return '主体';
    }
  }
  const labelEnum = { text: '文本', num: '数值', date: '日期' };
  return labelEnum[fieldDetail.type] || '-';
};

const getmultiHandlerOptions = fieldDetail => {
  if (!fieldDetail) {
    return [];
  }
  if (fieldDetail.type === 'text') {
    if (couldGroupFiled(fieldDetail)) {
      return [{ value: 'MAX', label: '多值取最优先排序的值' }];
    }
    return [{ value: 'MAX', label: '多值视为“有”' }];
  }
  if (fieldDetail.type === 'num') {
    return [
      { value: 'MAX', label: '取最大值' },
      { value: 'MIN', label: '取最小值' },
      { value: 'SUM', label: '取求和' },
      { value: 'AVG', label: '取平均值' }
    ];
  }
  if (fieldDetail.type === 'date') {
    return [
      { value: 'MIN', label: '取最远日期' },
      { value: 'MAX', label: '取最近日期' }
    ];
  }
  return [];
};

const dictValInfo = ref({});
const getDictValKey = sortInfo => `${sortInfo.uniqueId}/${sortInfo.fieldInfo.field_name}`;
const loadDictValHandle = async sortInfo => {
  const curItemKey = getDictValKey(sortInfo);
  let curItem = dictValInfo.value[curItemKey];
  if (curItem) {
    return;
  }
  try {
    curItem = { loading: true, dictList: [] };
    dictValInfo.value = {
      ...dictValInfo.value,
      [curItemKey]: curItem
    };
    const result = await services.caseRule.getKeywordByField({
      courseware_id: props.courseId,
      labelId: sortInfo.fieldInfo.field_name,
      keyword: ''
    });
    dictValInfo.value = {
      ...dictValInfo.value,
      [curItemKey]: {
        loading: false,
        dictList: Object.freeze(
          result.data.map(o => {
            return `${o.label || '-'}(${o.total || 0})`;
          })
        )
      }
    };
  } catch (err) {
    errFunc(err);
    dictValInfo.value = {
      ...dictValInfo.value,
      [curItemKey]: { loading: false, dictList: [] }
    };
  }
};
</script>
<style lang="scss">
.sort-field-dict-preview-popover {
  .sort-field-dict-list {
    width: 278px;
    box-sizing: border-box;
    min-height: 200px;
    max-height: 400px;
    padding: 6px 0;
    overflow-x: hidden;
    overflow-y: auto;

    &::-webkit-scrollbar {
      display: none;
    }
    .sort-field-dict-text {
      font-size: 14px;
      line-height: 20px;
      padding: 4px 10px;

      &:hover {
        background-color: #f6f7fa;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.custom-sort-modal {
  max-height: $dialogBodyMaxHeight;
  overflow-x: hidden;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }

  .custom-sort-group {
    color: #3d465a;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 12px;
  }

  .custom-sort-ul {
    .custom-sort-item {
      position: relative;
      display: flex;
      align-items: flex-start;
      padding: 5px 0;

      &:first-child {
        margin-top: 0;
      }

      & > * {
        position: relative;
        z-index: 2;
      }

      ::v-deep .el-select {
        width: 160px;
        margin-left: 10px;

        &.sort-way-select {
          width: 180px;
          .el-input--prefix {
            .el-input__inner {
              padding-left: 15px;
              padding-right: 45px;
            }
            .el-input__prefix {
              left: calc(100% - 55px);
            }
          }
        }
      }
      .custom-sort-tools {
        margin-left: 10px;
        & > i {
          cursor: pointer;
          font-size: 16px;
          color: #a0acc0;
          line-height: 24px;
          padding: 4px;

          &.el-icon-circle-plus-outline {
            color: #409eff;
          }
        }
      }

      &.is-high-light {
        @keyframes blink {
          0% {
            opacity: 0.3;
          }
          50% {
            opacity: 1;
          }
          100% {
            opacity: 0.3;
          }
        }
        &::before {
          content: '';
          position: absolute;
          left: 0px;
          right: 10px;
          top: 0px;
          bottom: 0;
          border: 1px solid #67c23a;
          opacity: 0;
          z-index: 1;
          animation: blink 2s 3;
        }
      }
    }
  }
}
</style>
